import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=ca2275fa&scoped=true&"
import script from "./AdminForm.vue?vue&type=script&lang=js&"
export * from "./AdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2275fa",
  null
  
)

export default component.exports